import * as React from 'react';
import {useEffect, useState} from 'react';
import {Button, CircularProgress, Grid, IconButton, Tooltip, Typography} from '@material-ui/core';
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {SearchBar} from '../sub-components/SearchBar';
import {addButtonColor} from '../sub-components/colors/colors';
import {AddNewRole} from './add-new-role/AddNewRole';
import {DeleteIcon, EditIcon,LockIcon,OpenLock} from '../privilages/according-list/AccordingList';
import {UserRolePopUp} from './user-role-pop-up/UserRolePopUp';
import {environment} from 'src/environments/environment';
import {AlertBar} from '../sub-components/AlertBar';
import {DeleteUserRole} from './delete-role/DeleteUserRole';
import {getLevel} from '../../app/utils';

const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    addNewRole: {
      backgroundColor: addButtonColor,
      color: "white",
      marginLeft: "10px",
      marginRight: "10px",
      textTransform: "none",
    },
    tableHeader: {
      backgroundColor: "#FFFFFF",
      color: "black",
      marginLeft: "15px",
      marginRight: "15px",
      marginTop: "15px",
      paddingTop: "8px",
      paddingBottom: "8px"
    },
    tableContent: {
      color: "black",
      marginLeft: "15px",
      marginRight: "15px",
    },
    viewButton: {
      backgroundColor: "#7C8E9633",
    },
    text: {
      marginTop: "8px"
    }
  }),
);

export function RolesComponent(props) {
  const classes = useStyles();
  const [addNew, setAddNew] = useState(false);
  const [openPopUp, setOpenPopUp] = useState(false);
  const [addNewType, setAddNewType] = useState();
  const [search, setSearch] = useState("")
  const [deletePopUp, setDeletePopUp] = useState(false);
  const [type,setType] = useState("")

  const [userRoles, setUserRoles] = useState([])
  const [userRoleId, setUserRoleId] = useState()
  const [userName, setUserName] = useState()
  const [description, setDescriptions] = useState()

  //alert states
  const [alertOpen, setAlertOpen] = useState(false)
  const [severity, setSeverity] = useState("success")
  const [topic, setTopic] = useState("")
  const [message, setMessage] = useState("")

  //loading states
  const [loading,setLoading] = useState(false)

  const openAddNew = (type, id, name, description) => {
    setUserRoleId(id)
    setUserName(name)
    setDescriptions(description)
    setAddNewType(type)
    setOpenPopUp(false)
    setAddNew(true);
  }
  const closeAddNew = () => {
    setSearch("")
    getUserRoles()
    setAddNew(false)
  }

  const openPopUpWindow = (roleId, name, description) => {
    setUserRoleId(roleId)
    setUserName(name)
    setDescriptions(description)
    setType("view")
    setOpenPopUp(true);
  }
  const closePopUpWindow = () => {
    setOpenPopUp(false);
    setDeletePopUp(false);
  }

  const getUserRoles = () => {
    setLoading(true)
    // this.spinner.show()
    fetch(`${environment.host}/ums/super/user-role`,
      {
        method: "GET",
        headers: {'Content-Type': 'application/json',Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')}
      }).then(response => response.json())
      .then(data => {
        if (data.message === "Success") {
          setUserRoles(data.content.sort((role1, role2) =>
            role1.id - role2.id
          ));
          setLoading(false)
        } else {
          setAlertOpen(true)
          setSeverity("error")
          setTopic("Error")
          setMessage(data.message)
          setTimeout(() => {
            setAlertOpen(false)
          }, 6000)
          setLoading(false)
        }
      })
  }

  const getCurrentUserRole = ():number =>{
    return parseInt(localStorage.getItem('ROLE'));
  }

  const getUserId = () => {
    console.log(localStorage.getItem('ROLE'))
    return localStorage.getItem('USER_ID');
  }

  const protectUserData =(id,isProtect)=>{
    // let protectIcon = document.getElementById("protect"+index) as HTMLElement
    // this.spinner.show()
    if(getCurrentUserRole() == 1 || isProtect == true){
      fetch(
        environment.host + '/ums/super/'+getUserId()+'/user-role-protect/' + id + '?isProtect=' + isProtect,
        {
          method: "PUT",
          headers: {'Content-Type': 'application/json',Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN')}}
      ).then((res)=>res.json())
      .then(data=>{
        getUserRoles()
      })
    }else{
      setLoading(false)
      setAlertOpen(true)
      setSeverity("error")
      setTopic("Error")
      setMessage("You Can't Unlock the Data.")
    }



    
  }

  const deletePopup = (id,name) =>{
    setDeletePopUp(true)
    setUserRoleId(id)
    setUserName(name)
  }


  useEffect(() => {
    // this.spinner.show()
    getUserRoles();
  }, [])

  return (
    <div className={`main-react-view`}>
      {
        addNew === false ?
          <Grid container>
            <Grid item xs={12} md={6}
                  style={{textAlign: 'right', display: 'flex', justifyContent: 'left', paddingLeft: '16px'}}>
              <SearchBar placeholder="Search Roles" onChange={(e) => setSearch(e.target.value)}/>
            </Grid>

            <Grid item xs={12} md={6} style={{textAlign: 'right', paddingRight: '4px'}}>
              <Button variant='contained' onClick={() => openAddNew("new-role", "", "", "")}
                      className={classes.addNewRole}> <img src='assets/images/Plus.svg' className='addIcon'/> New Role</Button>
            </Grid>

            <Grid container className={classes.tableHeader}>
              <Grid item xs={1} md={1}>
                <Typography style={{fontWeight: "bold", textAlign: "left", paddingLeft: "25px"}}>Id</Typography>
              </Grid>
              <Grid item xs={2} md={2}>
                <Typography style={{fontWeight: "bold", textAlign: "left", paddingLeft: "30px"}}>Level</Typography>
              </Grid>
              <Grid item xs={2} md={2}>
                <Typography style={{fontWeight: "bold", textAlign: "left", paddingLeft: "30px"}}>Role Name</Typography>
              </Grid>
              <Grid item xs={4} md={4}>
                <Typography
                  style={{fontWeight: "bold", textAlign: "left", paddingLeft: "40px"}}>Description</Typography>
              </Grid>
              <Grid item xs={2} md={2}>
                <Typography style={{fontWeight: "bold", paddingRight: "5px"}}>Actions</Typography>
              </Grid>
            </Grid>

            {
              userRoles.filter((obj) => {
                if (search === "") {
                  return obj
                } else if (obj.name.toLowerCase().includes(search.trim().toLowerCase())) {
                  return obj
                }
              }).map((role, index) => {
                return (
                  <Grid container className={classes.tableContent} key={index}
                        style={{backgroundColor: ((index % 2) === 0 || (index / 2) === 0) ? "#F9F9F9" : "white"}}>
                    <Grid item xs={1} md={1} style={{textAlign: "left", paddingLeft: "25px"}}>
                      <Tooltip title={role.id ? role.id.toString():""} placement="bottom-start" arrow>
                        <Typography
                          className={classes.text}>{role.id.toString().length > 6 ? role.id.toString().substring(0, 6) + "..." : role.id}</Typography>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={2} md={2} style={{ textAlign: "left", paddingLeft: "25px" }}>
                      <Tooltip title={getLevel(role.id)} placement="bottom-start" arrow>
                       <Typography className={classes.text}>{getLevel(role.id)}</Typography>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={2} md={2} style={{textAlign: "left", paddingLeft: "30px"}}>
                      <Tooltip title={role.name? role.name:""} placement="bottom-start" arrow>
                        <Typography
                          className={classes.text}>{role.name.length > 15 ? role.name.substring(0, 15) + "..." : role.name}</Typography>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={4} md={4} style={{textAlign: "left", paddingLeft: "35px"}}>
                      <Tooltip title={role.description?role.description:""} placement="bottom-start" arrow>
                        <Typography
                          className={classes.text}>{role.description !== undefined && role.description.length > 40 ? role.description.substring(0, 40) + "..." : role.description}</Typography>
                      </Tooltip>
                    </Grid>
                    <Grid item xs={2} md={2} style={{display:"flex"}}>
                      <IconButton data-toggle='tooltip' title='View' onClick={() => openPopUpWindow(role.id, role.name, role.description)}>
                        <ViewIcon/>
                      </IconButton>
                      <IconButton data-toggle='tooltip' title='Edit' onClick={() => openAddNew('edits', role.id, role.name, role.description)} disabled={role.protect == true} style={{opacity:role.protect === true ? 0.5:1}}>
                        <EditIcon/>
                      </IconButton>
                      <IconButton data-toggle='tooltip' title='Delete' onClick={() => deletePopup(role.id, role.name)} disabled={role.protect == true} style={{opacity:role.protect === true ? 0.5:1}}>
                        <DeleteIcon/>
                      </IconButton>
                      {role.protect == true ?
                        <IconButton data-toggle='tooltip' title='Protect' onClick = {()=>protectUserData(role.id,!role.protect)}>
                          <LockIcon/>
                        </IconButton>
                        :
                        <IconButton data-toggle='tooltip' title='Protect' onClick = {()=>protectUserData(role.id,!role.protect)}>
                          <OpenLock/>
                        </IconButton>
                      }

                    </Grid>
                  </Grid>
                );
              })
            }

          </Grid>
          : <AddNewRole onClose={() => closeAddNew()} type={addNewType} userRoleId={userRoleId} userName={userName}
                        description={description} getUserRoles={()=>getUserRoles()} userRoles={userRoles}
                        setAlertOpen={setAlertOpen} setSeverity={setSeverity} setTopic={setTopic} setMessage={setMessage}/>
      }

      <UserRolePopUp open={openPopUp} description={description} userName={userName} userRoleId={userRoleId}
                     onClose={() => closePopUpWindow()} type={type} getUserRoles={()=>getUserRoles()} 
                     addNew={(type, id, name, description) => openAddNew(type, id, name, description)} 
                     setAlertOpen={setAlertOpen} setSeverity={setSeverity} setTopic={setTopic} setMessage={setMessage}
      />

      <DeleteUserRole open={deletePopUp} getUserRoles={() => getUserRoles()} onClose={() => closePopUpWindow()}
                      setAlertOpen={setAlertOpen} setSeverity={setSeverity} setTopic={setTopic} setMessage={setMessage}
                      getUserId={() => getUserId()} userName={userName} id={userRoleId}/>
      <AlertBar open={alertOpen} severity={severity} topic={topic} message={message}/>
      {loading &&
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          backgroundColor: '#000000',
          opacity: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          width: '100vw',
          height: '100vh'
        }}>
          <CircularProgress size={80}/>
        </div>
      }
    </div>
  );
}

const ViewIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20.25' height='15' viewBox='0 0 20.25 15'>
      <g id='eye_1_' data-name='eye (1)' transform='translate(0.5 0.5)'>
        <path id='Path_13136' data-name='Path 13136' d='M1,11s3.5-7,9.625-7,9.625,7,9.625,7-3.5,7-9.625,7S1,11,1,11Z'
              transform='translate(-1 -4)' fill='none' stroke='#707070' strokeLinecap='round' strokeLinejoin='round'
              strokeWidth='1.6'/>
        <circle id='Ellipse_366' data-name='Ellipse 366' cx='3' cy='3' r='3' transform='translate(6.661 4)' fill='none'
                stroke='#707070' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.6'/>
      </g>
    </svg>
  );
};
